import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { filter, takeUntil } from 'rxjs';

import { ICategory, IQuestion, SdFaqComponent } from '@seb/web-design-system/faqs';

import { FaqVpcCmsParagraphComponentInterface, FaqVpcCollection } from '../../../models';
import { ComponentService, TrackingService } from '../../../services';
import { AbstractComponent } from '../abstract-component.component';

@Component({
  selector: 'wc-faq-vpc-cms-paragraph',
  templateUrl: './faq-vpc-cms-paragraph.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdFaqComponent]
})
export class FAQVPCCMSParagraphComponent extends AbstractComponent<FaqVpcCmsParagraphComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'is-weird'].filter(Boolean).join(' ');
  }

  categories: ICategory[];
  titleLevelCategory = 2;

  constructor(
    private componentService: ComponentService,
    private cdRef: ChangeDetectorRef,
    private trackingService: TrackingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.component$
      .pipe(
        this.componentService.reloadComponentForArrayProperties(['faqvpccollection']),
        filter((cmp: FaqVpcCmsParagraphComponentInterface) => cmp.faqvpccollection !== undefined),
        takeUntil(this.destroy$)
      )
      .subscribe((cmp: FaqVpcCmsParagraphComponentInterface) => {
        this.categories = [
          {
            title: cmp.theme,
            titleLevel: 2,
            questions: this.convertQuestions(cmp.faqvpccollection)
          }
        ];

        this.setLoaded();
        this.cdRef.markForCheck();
      });
  }

  onCategoryOpened(categoryName: string): void {
    this.trackingService.sendEvent('FAQ', { faqTopic: categoryName });
  }

  private convertQuestions(node: FaqVpcCollection): IQuestion[] {
    return Object.values(node).map((item) => ({
      id: item.code,
      answer: item.response,
      question: item.question
    }));
  }
}
